module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("applet订单详情")])], 1), _vm._v(" "), _c('div', [_c('div', [_c('el-table', {
    ref: "tradeTable",
    attrs: {
      "data": _vm.tableRefData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "申请记录"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "联系人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请原因",
      "prop": "refreason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "tradeTable",
    attrs: {
      "data": _vm.tableDataRef
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "退款申请"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "payTotal",
      "label": "可退金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("￥" + _vm._s((scope.row.payTotal - scope.row.refTotal) / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "退款金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "100px"
          },
          model: {
            value: (_vm.okRefPrice),
            callback: function($$v) {
              _vm.okRefPrice = $$v
            },
            expression: "okRefPrice"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "80%"
          },
          model: {
            value: (_vm.remark),
            callback: function($$v) {
              _vm.remark = $$v
            },
            expression: "remark"
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "150px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "width": "250px"
    }
  }, [_vm._v("退款金额：" + _vm._s(_vm.okRefPrice))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary",
      "disabled": this.$route.query.payStatus == 'ok' && this.$route.query.refStatus != '4' || this.refFlag
    },
    on: {
      "click": function($event) {
        _vm.refProduct()
      }
    }
  }, [_vm._v("确认退款")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "50px"
    },
    on: {
      "click": function($event) {
        _vm.getBack()
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "width": "200px"
    }
  }, [_vm._v("订单号： " + _vm._s(_vm.orderId))]), _vm._v(" "), _c('el-table', {
    ref: "tradeTable",
    attrs: {
      "data": _vm.tableDataPro
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品出货明细"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proPayTotal",
      "label": "实付金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("￥" + _vm._s(scope.row.proPayTotal / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proStatus",
      "label": "商品状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.proStatus == '') ? _c('div', [_c('div', [_vm._v("未出货")])]) : _vm._e(), _vm._v(" "), (scope.row.proStatus != '') ? _c('div', [_c('div', [_vm._v(_vm._s(scope.row.proStatus))])]) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "tradeTable",
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "退款记录"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "wechat_refund_id",
      "label": "退款流水号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refund_time",
      "label": "申请时间",
      "formatter": _vm.updateformatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_fee",
      "label": "退款金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("￥" + _vm._s(scope.row.total_fee / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refund_status",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.refund_status == '0') ? _c('div', [_vm._v("未退款")]) : (scope.row.refund_status == '1') ? _c('div', [_vm._v("已退款")]) : (scope.row.orderStatus == '') ? _c('div', [_vm._v("退款失败")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d7dd531!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/order/orderRef.vue
// module id = 1068
// module chunks = 2